import React, { useState, useEffect } from 'react';
import SingleLineTitle from '../../../../Components/TitleElements/SingleLineTitle';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '../../../../Components/Button/Button';
import { serviceConsumer } from '../../../../network/ServiceConsumer';
import Loader from '../../../../Components/Loader/Loader';
import moment from 'moment';
import Help from '../../../../Components/Help/Help';
import HeaderOrg from '../../../Headers/HeaderOrg';
import { formatDate } from '../../../../helper/formatDate';
import { getClosed } from '../../../../helper/setLocalStorage';
const EVENT_TYPES = ['feis', 'grade'];
const isEventType = (type) => EVENT_TYPES.includes(type);

const EventDetails = () => {
  const [event, setEvent] = useState();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [loadFailed, setLoadFailed] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const eventId = searchParams.get('id');
  // The event type comes from the URL first; localStorage 'Manage' is only set
  // by the event list and is wiped on login, so a direct link can't rely on it.
  const urlType = searchParams.get('Manage');
  const storedType = localStorage.getItem('Manage');
  const [ManageType, setManageType] = useState(
    isEventType(urlType) ? urlType : isEventType(storedType) ? storedType : null
  );
  const [showUI, setShowUI] = useState(false)

  useEffect(() => {
    setLoading(true);
    getEventDetail();
  }, []);

  const navigate = useNavigate();
  const editButtonHandler = () => {
    localStorage.setItem('TAB', 1);
    localStorage.setItem('ID', eventId);
    localStorage.setItem("redirectFeis", "edit")
    ManageType == 'feis' ? navigate('/organizer-create-feisanna') : navigate('/organizer-create-grade');
  };

  const fetchEvent = async (type) => {
    const url =
      type === 'feis'
        ? `${process.env.REACT_APP_BASE_URL}/feis/${eventId}`
        : `${process.env.REACT_APP_BASE_URL}/grade-exam/${eventId}`;
    const response = await serviceConsumer('GET', url);
    return type === 'feis' ? response?.Feis : response?.grade_exams;
  };

  //get event by eventId for event details
  //tries the known type first, then the other one (the type may be missing or stale)
  const getEventDetail = async () => {
    const preferred = ManageType || 'feis';
    const order = [preferred, ...EVENT_TYPES.filter((type) => type !== preferred)];
    let found;
    let foundType;
    if (eventId) {
      for (const type of order) {
        try {
          found = await fetchEvent(type);
          if (found) {
            foundType = type;
            break;
          }
        } catch (error) {
          // signed out / not allowed: the app is already redirecting to login.
          // serviceConsumer copies the body's `status` into statuscode, so read
          // the HTTP status from the axios error it wraps.
          const httpStatus = error?.error?.response?.status;
          if (httpStatus === 401 || httpStatus === 403) break;
        }
      }
    }
    if (found) {
      setEvent(found);
      setManageType(foundType);
      localStorage.setItem('Manage', foundType);
    } else {
      setLoadFailed(true);
    }
    setShowUI(true);
    setLoading(false);
  };

  const backClickHandler = () => {
    // no type, or the event didn't load (so its manage page can't either): back to the dashboard
    if (!ManageType || !eventId || loadFailed) return navigate('/organizer-dashboard');
    ManageType == 'feis' ? navigate(`/organizer-manage-feis?id=${eventId}&Manage=feis`) : navigate(`/organizer-manage-grade?id=${eventId}&Manage=grade`)
  }

  return (
    <div>
      {loading && <Loader />}
      <HeaderOrg />
      <SingleLineTitle titleName="Manage event" onBackClick={backClickHandler} />
      <div className="org-body-white">
        {!loading && showUI && loadFailed && (
          <div className="mt-3">
            <div className="org-body-title">Event not found</div>
            <span style={{ fontSize: '16px' }}>We couldn't load this event. Go back and open it again from your dashboard.</span>
          </div>
        )}
        {!loading && showUI && !loadFailed && event && (
          <>
            <div className="d-flex justify-content-between mt-3">
              <div>
                <div className="org-body-title">Event Details</div>
                <span style={{ fontSize: '16px', color: ' #424242;' }}>Complete these details to create event.</span>
              </div>
              <div className="d-flex align-items-end">
               {!getClosed()&& <Button className="filled" onClick={editButtonHandler}>Edit</Button>}
              </div>
            </div>
            <div className="hr-org-body mt-1" />
            <div className="d-md-flex mt-5 gap-5" style={{ marginBottom: '100px' }}>
              <div className="col-md-6 ">
                <div className="org-body-title">Event Details</div>
                <div className="hr-org-body mt-1" />

                <div className="search-label mt-3 mx-0">{event?.eventType === 'Grade Exam' ? 'Name of Exam:' : 'Name of Feis:'}</div>
                <div className="feis-manage">{event?.name}</div>

                <div className="search-label mt-3 mx-0">
                  {event?.eventType === 'Grade Exam' ? 'Exam Contact Email:' : 'Feis Contact Email:'}
                </div>
                <div className="feis-manage">{event?.contact_email}</div>

                <div className="search-label mt-3 mx-0">Region:</div>
                <div className="feis-manage">{event?.region}</div>

                <div className="search-label mt-3 mx-0">{event?.eventType === 'Grade Exam' ? 'Exam Date:' : 'Feis Date:'}</div>
                <div className="feis-manage">
                  {moment(formatDate(event?.eventType === 'Grade Exam' ? event?.exam_date : event?.feis_date)).format('MM/DD/YYYY')}
                </div>

                <div className="search-label mt-3 mx-0">Reg. Open Date:</div>
                <div className="feis-manage">
                  {moment(formatDate(event?.opening_date)).format('MM/DD/YYYY')}
                </div>

                <div className="search-label mt-3 mx-0">Reg. Close Date:</div>
                <div className="feis-manage">
                  {moment(formatDate(event?.closing_date)).format('MM/DD/YYYY')}
                </div>

                <div className="search-label mt-3 mx-0">Late Entries End:</div>
                <div className="feis-manage">
                  {event?.lateEntryCloseDate
                    ? moment(formatDate(event.lateEntryCloseDate)).format('MM/DD/YYYY')
                    : `${event?.eventType === 'Grade Exam' ? 'Exam' : 'Feis'} day (not set)`}
                </div>

                <div className="search-label mt-3 mx-0">Print Card Visible From:</div>
                <div className="feis-manage">{event?.printCardVisibleDate ? moment(formatDate(event.printCardVisibleDate)).format('MM/DD/YYYY') : 'Not set (always visible)'}</div>
              </div>

              <div className="col-md-6">
                <div className="org-body-title mt-5 mt-md-0">Venue Details</div>
                <div className="hr-org-body mt-1" />

                <div className="search-label mt-3 mx-0">Venue Name:</div>
                <div className="feis-manage">{event?.venue_name}</div>

                <div className="search-label mt-3 mx-0">Address:</div>
                <div className="feis-manage">
                  <div>{event?.venue},</div>
                  <div>{event?.venue_city},</div>
                  <div>{event?.region},</div>
                  <div>{event?.country}-{event?.postal_code}.</div>
                </div>
              </div>
            </div>
          </>
        )}
        {!loading && err && (<div className="d-flex justify-content-center" style={{ color: 'red', fontSize: '12px' }} > {err}</div>)}
      </div>
      <Help />
    </div>
  );
};

export default EventDetails;
